import React from 'react';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { buildLoginPath } from '../common/authRedirect';
import {
  dashboardMainColumnSx,
  dashboardMainGridSx,
  dashboardShellSx,
  dashboardTitleSx,
} from './dashboardMuiStyles';
import RecentCoursesSection from './RecentCoursesSection';
import RecentReplaySection from './RecentReplaySection';
import PuzzleSpotlightSection from './PuzzleSpotlightSection';
import ReviewBacklogSection from './ReviewBacklogSection';

const DashboardPage = () => {
  const { isLoggedIn, authChecked } = useAuth();
  const location = useLocation();

  if (!authChecked) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '50vh',
        }}
      >
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (!isLoggedIn) {
    const returnTo = `${location.pathname}${location.search}`;
    return <Navigate to={buildLoginPath(returnTo)} replace />;
  }

  return (
    <Box sx={dashboardShellSx}>
      <Typography variant="h4" component="h1" sx={dashboardTitleSx}>
        Dashboard
      </Typography>

      <Stack spacing={{ xs: 2.5, xxl: 3, xxxl: 3.5 }}>
        <ReviewBacklogSection />
        <PuzzleSpotlightSection />

        <Box sx={dashboardMainGridSx}>
          <Box sx={dashboardMainColumnSx}>
            <RecentCoursesSection />
          </Box>
          <Box sx={dashboardMainColumnSx}>
            <RecentReplaySection />
          </Box>
        </Box>
      </Stack>
    </Box>
  );
};

export default DashboardPage;
